<template>
  <div class="inner-wrapper">
    <default-layout>
      <nuxt />
      <page-footer v-if="canAccess" />
    </default-layout>
  </div>
</template>

<script>
import DefaultLayout from '~/layouts/default'
import PageFooter from '~/components/page-footer'

export default {
  components: {
    DefaultLayout,
    PageFooter
  },
  computed: {
    canAccess () {
      return this.$store.getters['user/account/canAccessApp']
    }
  }
}
</script>

<style lang="scss" scoped>
.inner-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  height: 100%;
  position: relative;
}

::v-deep main.body {

  > section {
    max-width: 48em;
    width: 100%;
    margin: $d-med auto auto;
    padding: 0 $d-med;

    @include breakpoint(medium) {
      margin-top: $d-x-large;
      padding: 0 $d-xx-large;
    }

    h1 {
      @include title-lrg;
      margin-bottom: $d-med-large;
    }

    .content {
      padding: 0 0 $d-x-large;

      p, a {
        @include body-med;
        margin-bottom: $d-small;
      }
    }
  }
}

</style>
